import React from 'react';
import { motion } from 'framer-motion';
export function TrainingMethod() {
  const lines = ['No es falta de ganas.', 'No es falta de disciplina.', 'Y tampoco es que no tengas talento'];
  return <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-[#223322] relative overflow-hidden" data-id="element-212">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#4caf50] opacity-[0.06] blur-[120px] rounded-full pointer-events-none" data-id="element-213" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-214">
        <div className="space-y-1.5 md:space-y-2 mb-4" data-id="element-215">
          {lines.map((line, i) => <motion.p key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.4,
          delay: 0.1 * i
        }} className="font-heading text-lg md:text-2xl lg:text-3xl font-bold text-[#a8c5a8]" data-id="element-216">
              {line}
            </motion.p>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 15,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="font-heading text-xl md:text-3xl lg:text-4xl font-black text-[#faf5e8] leading-tight" data-id="element-217">
          es la falta de un{' '}
          <span className="text-[#c8e6c9] border-b-4 border-[#c8e6c9] whitespace-nowrap" data-id="element-218">
            sistema
          </span>
        </motion.p>
      </div>
    </section>;
}